import { render, staticRenderFns } from "./scene.vue?vue&type=template&id=e14165ba&scoped=true&"
import script from "./scene.vue?vue&type=script&lang=js&"
export * from "./scene.vue?vue&type=script&lang=js&"
import style0 from "./scene.vue?vue&type=style&index=0&id=e14165ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14165ba",
  null
  
)

export default component.exports